import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { ProductionCenterType } from '../../types';

import { ProductionCenterDetail } from './components';

type ProductionCenterDetailsCardProps = {
  productionCenter: ProductionCenterType;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (productionCenter: ProductionCenterType) => void;
};

export function ProductionCenterDetailCard({
  isCollapsed,
  productionCenter,
  onCollapse,
  onUpdate,
}: ProductionCenterDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      title={productionCenter.name}
      className="w-full text-secondary-10"
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <ProductionCenterDetail productionCenter={productionCenter} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
